import { logOutUser } from '../../actions/authActions'

export default () => (dispatch) => {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  window.location.reload()
  dispatch(logOutUser())
}
